/* eslint-disable max-lines */
/* TODO: remove the above line and reduce the line count */

import dayjs from 'dayjs';

import { pushToReactSnackbar } from './reactTreeMounting';
import * as patient from 'FRONTEND/utils/backendApi/patient';
import i18n from 'FRONTEND/utils/i18n';


function updateBirthPlace() {
  const birthCountry = $('#patient-birth_country').val();
  const birthPlace = $('#patient-birthplace');
  const birthPlaceInsee = $('#patient-birthplace_insee');
  const tenantsInfo = $('#patient-tenant_id');
  let tenantId;
  if (typeof tenantsInfo.data('tenant-id') !== 'undefined') {
    tenantId = tenantsInfo.data('tenant-id');
  } else {
    tenantId = tenantsInfo.val();
  }
  const tenants = tenantsInfo.data('tenants-insee');

  if (tenants && tenants.includes(tenantId) && birthCountry === 'France') {
    birthPlace.val('').addClass('hidden');
    birthPlaceInsee.parent('div').removeClass('hidden');
  } else {
    birthPlace.removeClass('hidden');
    birthPlaceInsee.val('').trigger('change')
      .parent('div').addClass('hidden');
  }
}

const tenantIDInputs = 'form#patients-create #patient-tenant_id, form#patients-update #patient-tenant_id';
$(document).ready(displayConfig);
$(document).on('change', tenantIDInputs, displayConfig);

function isPatientUnique() {
  const tenantElement = $(tenantIDInputs).first();
  const tenantId = tenantElement.val();
  return tenantElement.data('tenants-unique') && tenantElement.data('tenants-unique').includes(tenantId);
}

function displayConfig() {
  /**
   * Manage Insee / test / unique functionalities according to the tenants configuration.
   */
  const tenantElement = $(tenantIDInputs).first();
  const tenantId = tenantElement.val();
  const patientUnique = isPatientUnique();

  updateBirthPlace();

  if (tenantElement.data('tenants-test') && tenantElement.data('tenants-test').includes(tenantId)) {
    $('#patient-test_patient').parents('.checkbox').removeClass('hidden');
  } else {
    $('#patient-test_patient').prop('checked', false)
      .parents('.checkbox').addClass('hidden');
  }

  if (patientUnique) {
    $('label.patient_unique').each(function applyRequired() {
      if (!$(this).find('span.star').length) {
        $(this).append('<span class="star">*</span>');
      }
    });
    $('input.patient_unique, select.patient_unique').prop('required', true);
  } else {
    $('label.patient_unique').each(function removeRequired() {
      $(this).find('span.star').remove();
    });
    $('input.patient_unique, select.patient_unique').prop('required', false);
  }
  handleHideFields();
}

$(document).on('change', '#patient-birth_country', updateBirthPlace);

$(document).on('click', 'a.patient-file-delete', function removePatientFileModal() {
  const removeAdministrativeFileWarning = $('#patient_file-delete-warning');
  if ($(this).data('is-admin')) {
    removeAdministrativeFileWarning.removeClass('hidden');
  } else {
    removeAdministrativeFileWarning.addClass('hidden');
  }
  const deleteModal = $('#patient_file-delete-modal');
  deleteModal.find('.modal-title').text($(this).data('file-name'));
  deleteModal.find('.modals-delete-validate').attr('data-delete-url', $(this).data('delete-url'));
  deleteModal.modal();
});

function chunkString(value, chunks) {
  /**
   * Chunks a string, according to the chunks array. Join by spaces.
   * @param   {string}    value
   * @param   {number[]}  chunks  Array of chunks sizes.
   * @return  {string}            Chunked value, joined by spaces.
   */
  const output = [];
  let position = 0;

  for (const chunk of chunks) {
    if (value.length <= position) {
      break;
    }
    output.push(value.substring(position, chunk + position));
    position += chunk;
  }

  return output.join(' ');
}

$(document).on('change input', '#patient-health_insurance-display', function formatHealthInsurance() {
  /**
   * Format health insurance company (adding space and removing invalid characters).
   */
  // Remove invalid characters like spaces, dots, underscores, and dashes.
  const value = $(this).val().replace(/\D+/g, '');
  $('#patient-health_insurance').val(value);

  $(this).val(chunkString(value, [2, 3, 4]));
});

$(document).on('change input', '#patient-health_insurance_contract_nb-display', function formatHealthInsuranceContractNumber() {
  /**
   * Format health insurance contract number (adding space and removing invalid characters).
   */
  // Remove invalid characters like spaces, dots, underscores, and dashes.
  const value = $(this).val().replace(/[^\dAB]+/g, '');
  $('#patient-health_insurance_contract_nb').val(value);

  $(this).val(chunkString(value, [1, 2, 2, 2, 3, 3, 2]));
});

export async function checkUniquePatient() {
  const patientID = $('#patient_id').text();

  const tenantEl = $('#patient-tenant_id');
  const birthdateEl = $('#patient-birthdate');
  const firstNameEl = $('#patient-first_name');
  const genderEl = $('#patient-gender');
  const lastNameEl = $('#patient-last_name');

  if (!birthdateEl.prop('required')) {
    return;
  }

  if (!birthdateEl.val() || !firstNameEl.val() || !genderEl.val() || !lastNameEl.val()) {
    return false;
  }

  const uniquePatient = await patient.getUniquePatient({
    tenant_id: tenantEl.val(),
    birthdate: birthdateEl.val(),
    first_name: firstNameEl.val(),
    gender: genderEl.val(),
    last_name: lastNameEl.val(),
  });

  const patientExists = Object.prototype.hasOwnProperty.call(uniquePatient, 'patient_id');
  const createDuplicate = !patientID && patientExists;
  const updateDuplicate = patientID && patientExists && uniquePatient.patient_id !== patientID;

  if (createDuplicate || updateDuplicate) {
    if (!firstNameEl.parent().hasClass('has-error')) {
      pushToReactSnackbar({ variant: 'error', message: i18n._('The patient already exists.'), link: uniquePatient.link });
    }
    for (const input of [birthdateEl, firstNameEl, genderEl, lastNameEl]) {
      input[0].setCustomValidity(i18n._('The patient already exists.'));
      input.parent().addClass('has-error');
    }
  } else {
    for (const input of [birthdateEl, firstNameEl, genderEl, lastNameEl]) {
      input[0].setCustomValidity('');
      input.parent().removeClass('has-error');
    }
  }
}

const uniquePatientInputs = '#patient-first_name, ' +
                            '#patient-last_name, ' +
                            '#patient-birthdate, ' +
                            '#patient-gender';
$(document).on('focusout', uniquePatientInputs, checkUniquePatient);

export function setupBirthplace() {
  const pageSize = 10;

  const selectBirthPlace = $('#patient-birthplace_insee').select2({
    ajax: {
      delay: 350,
      dataType: 'json',
      type: 'GET',
      quietMillis: 100,
      cache: true,
      url: 'https://public.opendatasoft.com/api/explore/v2.1/catalog/datasets/correspondance-code-insee-code-postal/records',
      data: function(params) {
        const page = params.page || 1;
        return {
          where: params.term ? `search(insee_com, nom_comm, postal_code, "${params.term}")` : '',
          order_by: 'nom_comm',
          limit: pageSize,
          offset: pageSize * (page - 1),
        };
      },
      processResults: function(data, params) {
        const page = params.page || 1;
        let results = [];

        if (data?.results) {
          results = data.results.map(
            r => ({
              id: `${r.insee_com}`,
              text: `${r.nom_comm} (${r.postal_code}) - INSEE ${r.insee_com}`,
              birthplace: `${r.nom_comm} (${r.postal_code})`,
            }),
          );
        }
        // Add an empty option on the first page.
        if (page === 1) {
          results.splice(0, 0, { id: '', text: '' });
        }
        return {
          pagination: {
            more: (page * pageSize) < (data?.total_count || 0),
          },
          results,
        };
      },
    },
    theme: 'bootstrap',
    width: '100%',
    minimumInputLength: 3,
  });
  selectBirthPlace.on('change', () => {
    const inseeSelect = $('#patient-birthplace_insee').select2('data');
    $('#patient-birthplace').val(inseeSelect && inseeSelect.length ? inseeSelect[0].birthplace : null);
  });
}

// Handle date of birth and age
// We can't use the id directly since some forms have consultations-[workflow form]-[id] for ids, so we use the jquery "ends with" selector
// see https://api.jquery.com/attribute-ends-with-selector/
$(document).on('change input', 'input[id$="patient-birthdate"]', calculateAgeFromDob);
$(document).on('change input', 'input[id$="patient-age"]', function clearDob() {
  $('input[id$="patient-birthdate"]').val(''); // when user manually changes age we clear the current dob.
});

// Calculate patient age from date of birth, and determine which unit to use (years || months || days)
function calculateAgeFromDob() {
  const birthdateValue = $('input[id$="patient-birthdate"]').val();
  if (!birthdateValue) {
    return;
  } // Exit if no date is selected

  const patientDOB = dayjs(birthdateValue);
  const currentDate = dayjs();

  // The DOB field accepts future dates. Clear the age and DOB field if input is in the future.
  if (patientDOB.isAfter(currentDate)) {
    $('input[id$="patient-age"]').val('');
    $('input[id$="patient-birthdate"]').val(''); // empty the field if date is in the future.
    return;
  }

  // Calculate age differences
  const yearAge = currentDate.diff(patientDOB, 'year');
  const monthAge = currentDate.diff(patientDOB, 'month');
  const dayAge = currentDate.diff(patientDOB, 'day');

  // Determine the appropriate unit
  if (yearAge > 0) {
    $('input[id$="patient-age"]').val(yearAge);
    $('select[id$="patient-age_unit"]').val('year').trigger('change');
  } else if (monthAge > 0) {
    $('input[id$="patient-age"]').val(monthAge);
    $('select[id$="patient-age_unit"]').val('month').trigger('change');
  } else {
    $('input[id$="patient-age"]').val(dayAge);
    $('select[id$="patient-age_unit"]').val('day').trigger('change');
  }
}

// We can't set dynamic date in JSON, so we override the max with the currentDate on DOM load
$(document).ready(function() {
  const currentDate = dayjs().format('YYYY-MM-DD');
  $('input[id$="patient-birthdate"]').attr('max', currentDate);
});

// Handle clear age/dob/estimated age fields
const dobAndAgeInputs = 'input[id$="patient-birthdate"], input[id$="patient-age"]';
const estimatedAgeInput = 'input[id$="patient-estimated_age"]';

const handleHideFields = () => {
  const dobValue = $('input[id$="patient-birthdate"]').val();
  const ageValue = $('input[id$="patient-age"]').val();
  const estimatedAgeValue = $('input[id$="patient-estimated_age"]').val();

  if (estimatedAgeValue === undefined || estimatedAgeValue === null) {
    return;
  }

  // Clear estimated age if patient_unique is enabled on the tenant
  const patientUnique = isPatientUnique();
  if (patientUnique) {
    $('input[id$="patient-estimated_age"]').val('');
    $('select[id$="patient-estimated_age_unit"]').val('').trigger('change');
  }

  const hasEstimatedAge = estimatedAgeValue !== '' && !patientUnique;
  const hasDobOrAge = (dobValue !== '' || ageValue !== '') || patientUnique;

  // Show/hide DOB and age fields
  // .parent() is the wrapping div for elements.
  $('input[id$="patient-birthdate"]').parent().toggle(!hasEstimatedAge);
  $('input[id$="patient-age"]').parent().toggle(!hasEstimatedAge);
  $('select[id$="patient-age_unit"]').parent().toggle(!hasEstimatedAge);
  $('input[id$="patient-estimated_age"]').parent().toggle(!hasDobOrAge);
  $('select[id$="patient-estimated_age_unit"]').parent().toggle(!hasDobOrAge);
};

$(document).on('pjax:end', () => handleHideFields()); // Ensure fields are hidden on PJAX end (when updating existing form)
$(document).on('change input', dobAndAgeInputs, () => handleHideFields());
$(document).on('change input', estimatedAgeInput, () => handleHideFields());
